import { GetServerSideProps } from "next";
import Head from "next/head";
import { FC } from "react";

import { Disclaimers } from "../components/Disclaimers";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AboutHero } from "../sections/about/AboutHero";
import { CompanyBackground } from "../sections/about/CompanyBackground";
import { Investors } from "../sections/about/Investors";
import { BrokerCheck } from "../sections/BrokerCheck";
import { Team } from "../sections/content/Team";
import {
  getServerSidePropsHelper,
  ServerProps,
} from "../utils/serverSidePropsHelper";

const About: FC<ServerProps> = ({ isKnownUser }) => {
  const title = "About us - Creating new opportunities for wealth";
  const description =
    "Frec simplifies sophisticated finance with powerful algorithms.";

  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel="canonical" href="https://frec.com/about" />
        <meta name="description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta
          property="og:image"
          content="https://frec.com/webstatic/images/share-img.png"
          key="og:image"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <>
        <Header isKnownUser={isKnownUser} />
        <main>
          <AboutHero />
          <CompanyBackground />
          <Investors />
          <Team />
        </main>
        <BrokerCheck />
        <Footer />
        <Disclaimers />
      </>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<ServerProps> = async ({
  req,
}) => {
  const props = getServerSidePropsHelper(req);
  return Promise.resolve({
    props,
  });
};

export default About;
